import { ConfigProvider, message } from 'antd';
import enUS from 'antd/locale/en_US';
import frFR from 'antd/locale/fr_FR';
import koKR from 'antd/locale/ko_KR';
import i18next from 'i18next';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { i18nClient } from './i18n';
import { register } from './serviceWorker';
import './styles/app.css';
import { EditorThemeProvider } from './theme';

const antResources: Record<string, typeof koKR> = {
	ko: koKR,
	'ko-KR': koKR,
	en: enUS,
	'en-US': enUS,
	fr: frFR,
	'fr-FR': frFR,
};

const rootElement = (() => {
	const existingRoot = document.getElementById('root');
	if (existingRoot) {
		return existingRoot;
	}
	const root = document.createElement('div');
	root.id = 'root';
	document.body.appendChild(root);
	return root;
})();

// Petits messages (message.*) : au milieu de l'écran, 3 au plus, dans le style Paddy (voir dtf.css « Toasts Paddy »)
message.config({ maxCount: 3, duration: 3.5 });

const root = createRoot(rootElement);

// Langue par défaut : français (avant le premier rendu)
if (!i18next.language || !i18next.language.startsWith('fr')) {
	i18next.changeLanguage('fr-FR');
}

const render = (Component: React.ElementType) => {
	root.render(
		<HelmetProvider>
			<ConfigProvider locale={antResources[i18next.language] || enUS}>
				<EditorThemeProvider>
					<Component />
				</EditorThemeProvider>
			</ConfigProvider>
		</HelmetProvider>,
	);
};

i18nClient();

render(App);

// filet : si l'éditeur ne retire pas lui-même l'écran d'attente (page autre que l'éditeur DTF, erreur), on le retire ici.
// 20.10.2026 : 20 s (l'éditeur le garde maintenant tant que les logos sauvegardés ne sont pas affichés, 8 s au plus ; index.html affiche « plus long que prévu » à 15 s)
setTimeout(() => {
	const el = document.getElementById('dtf-splash');
	if (el) {
		el.classList.add('out');
		setTimeout(() => el.remove(), 400);
	}
}, 20000);

register();
